import { autoMount } from '../../../utils/autoMount';
import { FixedPageBottomLinks } from '../../../components/organisms/fixedPageBottomLinks';

autoMount({ FixedPageBottomLinks });
